import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import banner from "../../../assets/Serviceasset/sevicebanner.png";
import prop1 from "../../../assets/Serviceasset/sevicebanner.png";
import { toast } from "react-toastify";
import axios from "axios";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../../../shadcn/components/ui/AlertDialog";

export default function MyPropertiesServices({
  properties: initialProperties,
}) {
  // State to handle the search input
  const [searchQuery, setSearchQuery] = useState("");
  const [properties, setProperties] = useState(initialProperties || []);
  const [isLoading, setIsLoading] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [propertyToDelete, setPropertyToDelete] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredProperties, setFilteredProperties] = useState([]);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [sortDirection, setSortDirection] = useState("asc");

  const navigate = useNavigate();

  // ==================================== Api integration ==============================
  // const token = localStorage.getItem("authToken");

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const token = localStorage.getItem("authToken");

      if (!token) {
        toast.error("Authentication token is missing. Please log in again.");
        setIsLoading(false);
        return;
      }

      try {
        const response = await axios.post(
          "https://silver-tlc-backend-delta.vercel.app/api/v1/alluser/postservice-form/get",
          { token },
          { headers: { "Content-Type": "application/json" } }
        );

        const propertyData = response.data?.form_data || [];
        // console.log(response.data?.form_data);

        // Map property data to frontend structure
        const mappedProperties = propertyData.map((item) => {
          return {
            id: item._id,
            name: item.propertyDetails?.title || "N/A",
            porpertyAddress: item.propertyDetails?.address || "N/A",
            price: item.propertyDetails?.price || "N/A",
            image: item.uploadFiles[0] || "/placeholder-image.jpg",
            details: item.propertyDetails || {}, // Add this line
            propertyDetails: item.propertyDetails || {},
            location: item.location || {},
            neighborhood: item.neighborhood || {},
            uploadFiles: item.uploadFiles || [],
            address: item.location?.address || "N/A",
          };
        });

        setProperties(mappedProperties.filter(Boolean)); // Remove null/undefined entries
        setFilteredProperties(mappedProperties.filter(Boolean));
      } catch (error) {
        console.error("Error fetching property data:", error.response?.data);
        toast.error(
          error.response?.data?.message ||
            "An unexpected error occurred while fetching data."
        );
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  // Delete services and transport data
  const handleDeleteClick = (property) => {
    setPropertyToDelete(property);
    setIsDeleteDialogOpen(true);
  };

  const handleDeleteConfirm = async () => {
    if (!propertyToDelete) return;

    const token = localStorage.getItem("authToken");
    if (!token) {
      toast.error("Authentication token is missing. Please log in again.");
      return;
    }

    try {
      const deleteUrl =
        "https://silver-tlc-backend-delta.vercel.app/api/v1/alluser/postservice-form/delete";

      await axios.delete(deleteUrl, {
        headers: { "Content-Type": "application/json" },
        data: { form_id: propertyToDelete.id, token },
      });

      setProperties((prevServices) =>
        prevServices.filter((s) => s.id !== propertyToDelete.id)
      );

      toast.success("Property deleted successfully!");
    } catch (error) {
      console.error("Error deleting property:", error.response);
      toast.error(
        error.response?.data?.message || "Failed to delete the property."
      );
    } finally {
      setIsDeleteDialogOpen(false);
      setPropertyToDelete(null);
    }
  };

  // type differentiation
  const formatServiceType = (property) => {
    if (property.details?.parking && property.details?.name) {
      return "Property Form";
    }
    return "Unknown";
  };

  // edit button
  const handleEditClick = (formType, property) => {
    if (!property) return;

    const formId = property.id;
    const formData = {
      propertyDetails: property.propertyDetails || {},
      location: property.location || {},
      neighborhood: property.neighborhood || {},
      uploadFiles: property.uploadFiles || [],
    };

    // Navigate and pass state correctly
    navigate("/propertyownerdashboard/Property", {
      state: { formData, formType, formId },
    });
  };

  // ================== Search feature =================
  const handleSearch = () => {
    if (searchTerm.trim() === "") {
      setFilteredProperties(properties); // Reset to all properties if search term is empty
    } else {
      const sortedProperties = [...properties].sort((a, b) => {
        const isAMatch = a.name
          .toLowerCase()
          .includes(searchTerm.toLowerCase());
        const isBMatch = b.name
          .toLowerCase()
          .includes(searchTerm.toLowerCase());

        if (isAMatch && !isBMatch) return -1; // a comes first
        if (!isAMatch && isBMatch) return 1; // b comes first
        return 0; // maintain original order if both match
      });

      setFilteredProperties(sortedProperties);
    }
  };

  // ================== filter feature =================
  const handleFilterClick = () => {
    setIsFilterOpen((prev) => !prev); // Toggle filter dropdown
  };

  const handleSortByPrice = () => {
    const sorted = [...filteredProperties].sort((a, b) => {
      if (sortDirection === "asc") {
        return a.price - b.price; // Ascending order
      } else {
        return b.price - a.price; // Descending order
      }
    });

    setFilteredProperties(sorted);
    setSortDirection((prev) => (prev === "asc" ? "desc" : "asc")); // Toggle direction
  };

  return (
    <div className="md:p-8 w-full">
      {/* Delete Dialog */}
      <AlertDialog
        open={isDeleteDialogOpen}
        onOpenChange={setIsDeleteDialogOpen}
      >
        <AlertDialogContent className="bg-white">
          <AlertDialogHeader>
            <AlertDialogTitle>Are you absolutely sure?</AlertDialogTitle>
            <AlertDialogDescription>
              This action cannot be undone. This will permanently delete your
              property and remove all associated data.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel
              className="bg-gray-100 hover:bg-gray-200"
              onClick={() => setPropertyToDelete(null)}
            >
              Cancel
            </AlertDialogCancel>
            <AlertDialogAction
              className="bg-red-600 hover:bg-red-700 text-white"
              onClick={handleDeleteConfirm}
            >
              Delete
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
      {/* Properties Table */}
      <div className="bg-white rounded-lg lg:p-6 overflow-x-auto w-[73vw] md:w-full">
        <div
          className="relative bg-cover bg-center h-64 lg:w-full lg:h-96 w-[73vw] rounded-lg overflow-hidden shadow-md"
          style={{ backgroundImage: `url(${banner})` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
            <div className="text-center text-white lg:px-8 overflow-x-auto">
              <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold">
                My Properties
              </h1>
              <div className="mt-4 flex flex-col sm:flex-row justify-center gap-2 sm:gap-0 relative">
                {/* Search Input */}
                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="Search for Properties"
                  className="w-[65vw] sm:w-[40rem] p-2 rounded-lg border-none text-lg focus:ring-0 text-black pl-5"
                />
                {/* Search Button */}
                <button
                  onClick={handleSearch}
                  className="w-full sm:w-auto px-6 py-2 bg-purple-600 text-white rounded-r-lg flex justify-center items-center hover:bg-purple-700 transition-all"
                >
                  Search
                </button>
                {/* Filter Button */}
                <button
                  onClick={handleFilterClick}
                  className="w-full sm:w-auto sm:ml-4 mt-2 sm:mt-0 px-6 py-2 bg-purple-600 text-white rounded-lg flex justify-center items-center hover:bg-purple-700 transition-all"
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="mr-2"
                  >
                    <path d="M0 3.375H18V1.125H0V3.375Z" fill="white" />
                    <path
                      d="M2.25 7.875H15.75V5.625H2.25V7.875Z"
                      fill="white"
                    />
                    <path
                      d="M4.5 12.375H13.5V10.125H4.5V12.375Z"
                      fill="white"
                    />
                    <path
                      d="M11.25 16.875H6.75V14.625H11.25V16.875Z"
                      fill="white"
                    />
                  </svg>
                  Filter
                </button>
                {/* Dropdown Menu */}
                {isFilterOpen && (
                  <div className="absolute top-full right-[-1rem] mt-2 bg-white text-black shadow-lg rounded-lg z-10 w-32">
                    <button
                      onClick={handleSortByPrice}
                      className="w-full text-left px-4 py-2 hover:bg-gray-100 transition-all text-black hover:rounded-lg"
                    >
                      Sort by Price (
                      {sortDirection === "asc" ? "Ascending" : "Descending"})
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <h2 className="text-2xl flex font-bold mb-4 mt-5 items-center">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="mr-2"
          >
            <path
              d="M22.9564 22.4348H20.6086V1.5652H21.3912C21.8234 1.5652 22.1738 1.21481 22.1738 0.782578C22.1738 0.350344 21.8234 0 21.3912 0C19.8626 0 3.31816 0 2.60857 0C2.17638 0 1.82595 0.350391 1.82595 0.782625C1.82595 1.21486 2.17634 1.56525 2.60857 1.56525H3.3912V22.4348H1.04337C0.61118 22.4348 0.260742 22.7852 0.260742 23.2174C0.260742 23.6497 0.611133 24 1.04337 24C1.51835 24 20.9871 24 22.9564 24C23.3886 24 23.739 23.6496 23.739 23.2174C23.739 22.7851 23.3886 22.4348 22.9564 22.4348ZM19.0434 22.4348H4.9564V1.5652H19.0434V22.4348Z"
              fill="black"
            />
          </svg>
          My Properties
          <svg
            width="5"
            height="5"
            viewBox="0 0 5 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="ml-2"
          >
            <circle cx="2.19095" cy="2.3815" r="2.19095" fill="#949494" />
          </svg>
        </h2>
        {/* Search Bar */}
        {/* <div className="mb-4">
          <input
            type="text"
            placeholder="Search properties..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div> */}
        <table className="table-auto border-b text-left border-collapse overflow-x-auto w-[80vw] lg:w-full">
          <thead>
            <tr className="border-b">
              <th className="p-4">Thumbnail Image</th>
              <th className="p-4">Property Name</th>
              <th className="p-4">Address</th>
              <th className="p-4">Price</th>
              <th className="p-4">Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredProperties.map((property) => (
              <tr key={property.id} className="border-b">
                <td className="p-4">
                  <img
                    src={property.image}
                    alt="Thumbnail"
                    className="h-32 w-48 object-cover rounded"
                  />
                </td>
                <td className="p-4">{property.name}</td>
                <td className="p-4">{property.address}</td>
                <td className="p-4">{property.price}</td>
                <td className="p-4 space-x-4 flex justify-start items-center mt-[3rem]">
                  <button
                    className=" flex items-center justify-center gap-2 text-sm"
                    onClick={(e) => {
                      e.preventDefault();
                      handleEditClick(formatServiceType(property), property);
                    }}
                  >
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.13388 14.8751L14.1339 4.87509L10.125 0.866211L0.125 10.8663V14.8751H4.13388ZM10.125 2.63398L12.3662 4.87509L10.75 6.49125L8.5089 4.25011L10.125 2.63398ZM7.62498 5.13399L9.86615 7.37509L3.61612 13.6251H1.375V11.384L7.62498 5.13399Z"
                        fill="#171A1F"
                      />
                    </svg>
                    Edit
                  </button>
                  <button
                    className=" flex items-center justify-center gap-2 text-sm"
                    onClick={() => handleDeleteClick(property)}
                  >
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.5599 5.3L11.5599 12.14C11.5599 12.7696 11.0495 13.28 10.4199 13.28L3.57994 13.28C2.95034 13.28 2.43994 12.7696 2.43994 12.14L2.43994 5.3"
                        stroke="#565D6D"
                        strokeWidth="1.368"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                      />
                      <path
                        d="M0.72998 3L13.27 3"
                        stroke="#565D6D"
                        strokeWidth="1.368"
                        strokeMiterlimit="10"
                        strokeLinecap="square"
                      />
                      <path
                        d="M4.71997 3L4.71997 0.720001L9.27997 0.720001V3"
                        stroke="#565D6D"
                        strokeWidth="1.368"
                        strokeMiterlimit="10"
                        strokeLinecap="square"
                      />
                      <path
                        d="M8.71004 7L5.29004 10.42"
                        stroke="#565D6D"
                        strokeWidth="1.368"
                        strokeMiterlimit="10"
                        strokeLinecap="square"
                      />
                      <path
                        d="M8.71004 10.42L5.29004 7"
                        stroke="#565D6D"
                        strokeWidth="1.368"
                        strokeMiterlimit="10"
                        strokeLinecap="square"
                      />
                    </svg>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {filteredProperties.length === 0 && (
          <p className="text-center text-gray-500 mt-4">
            No properties match your search.
          </p>
        )}
      </div>
    </div>
  );
}
